import i18n from "../translations/i18n";

export const contactTopics = [{
  key: 0, item: "Ontwikkeling", label: i18n.t("development"), info: "Vertel ons iets over je project"
}, {
  key: 1, item: "Consultancy", label: i18n.t("consultancy"), info: "Waarover heb je advies nodig?"
}, {
  key: 2, item: "Overig", label: i18n.t("other"), info: "Waar wil je het met ons over hebben?"
}]